import { logger } from "./utils/logger.es.js";
import { v as v4 } from "./v4-88c20f3b.js";
import { timeExpiredCheck } from "./browser/plugins/visitId/utils.es.js";
import { URL_VISIT_IDS, EH_VISIT_ID, EH_VISIT_TS } from "./browser/plugins/visitId/constants.es.js";
const EH_EVENT_TIME = "eh_event_time";
const EH_PAGE_VIEW_ID = "eh_page_view_id";
const EH_PREVIOUS_PAGE_VIEW_ID = "eh_previous_page_view_id";
const EH_PAGE_NAME = "eh_page_name";
const PAGE_VIEW_ID = "page_view_id";
const TIME_SINCE_LAST_EVENT = "time_since_last_event";
const getSessionStorageData = (key) => window.sessionStorage.getItem(key);
const setSessionStorageData = (key, value) => window.sessionStorage.setItem(key, value);
const timeOnPage = (eventType, pageName) => {
  if (!eventType || !pageName) {
    return { [PAGE_VIEW_ID]: void 0, [TIME_SINCE_LAST_EVENT]: void 0 };
  }
  const eventTime = new Date(getSessionStorageData(EH_EVENT_TIME)) || null;
  const currentPageName = getSessionStorageData(EH_PAGE_NAME) || null;
  const pageId = getSessionStorageData(EH_PAGE_VIEW_ID) || null;
  let timeDifference;
  if (eventType === "page") {
    if (!pageId) {
      const newPageViewId = v4();
      setSessionStorageData(EH_EVENT_TIME, /* @__PURE__ */ new Date());
      setSessionStorageData(EH_PAGE_VIEW_ID, newPageViewId);
      setSessionStorageData(EH_PAGE_NAME, pageName);
      return {
        [PAGE_VIEW_ID]: newPageViewId,
        [TIME_SINCE_LAST_EVENT]: 0
      };
    } else {
      const currentTime = /* @__PURE__ */ new Date();
      timeDifference = timeCalculation(currentTime, eventTime);
      setSessionStorageData(EH_EVENT_TIME, currentTime);
      setSessionStorageData(EH_PAGE_NAME, pageName);
      if (pageName !== currentPageName) {
        setSessionStorageData(EH_PAGE_VIEW_ID, v4());
        setSessionStorageData(EH_PREVIOUS_PAGE_VIEW_ID, pageId);
      }
      return {
        [PAGE_VIEW_ID]: pageId,
        [TIME_SINCE_LAST_EVENT]: timeDifference
      };
    }
  } else {
    if (pageName !== currentPageName) {
      const newPageId = v4();
      setSessionStorageData(EH_PAGE_NAME, pageName);
      setSessionStorageData(EH_PAGE_VIEW_ID, newPageId);
      const currentTime2 = /* @__PURE__ */ new Date();
      timeDifference = timeCalculation(currentTime2, eventTime);
      return {
        [PAGE_VIEW_ID]: newPageId,
        [TIME_SINCE_LAST_EVENT]: timeDifference
      };
    }
    const currentTime = /* @__PURE__ */ new Date();
    timeDifference = timeCalculation(currentTime, eventTime);
    setSessionStorageData(EH_EVENT_TIME, currentTime);
    return {
      [PAGE_VIEW_ID]: pageId,
      [TIME_SINCE_LAST_EVENT]: timeDifference
    };
  }
};
const timeCalculation = (currentTime, eventTime) => {
  if (isNaN(currentTime.getTime()) || isNaN(eventTime.getTime())) {
    return 0;
  }
  return parseInt(
    (Math.abs(currentTime.getTime() - eventTime.getTime()) / 1e3).toFixed(1),
    10
  );
};
const updateVisitCookiesArray = (visitId, cookies, cookieHandler, cookieOptions) => {
  const urlVisitIdsArr = cookies[URL_VISIT_IDS] ? JSON.parse(cookies[URL_VISIT_IDS]) : [];
  urlVisitIdsArr.unshift(visitId);
  const currentTime = /* @__PURE__ */ new Date();
  cookieHandler.setCookie(
    {
      [EH_VISIT_ID]: visitId,
      [EH_VISIT_TS]: currentTime.toString(),
      [URL_VISIT_IDS]: JSON.stringify(urlVisitIdsArr)
    },
    [cookieOptions, cookieOptions, cookieOptions]
  );
};
const handleExistingUrlVisitId = (cookies, urlVisitId, urlVisitIdTs, cookieOptions, cookieHandler) => {
  const currentTime = /* @__PURE__ */ new Date();
  const ehVisitIdSetTime = urlVisitIdTs ? new Date(Number(urlVisitIdTs)) : currentTime;
  const timeDifference = timeCalculation(currentTime, ehVisitIdSetTime);
  if (urlVisitId === cookies[URL_VISIT_IDS][0]) {
    const visitId = timeExpiredCheck(timeDifference, urlVisitId, cookieOptions, cookieHandler);
    updateVisitCookiesArray(visitId, cookies, cookieHandler, cookieOptions);
    return visitId;
  } else {
    let visitId = cookies[EH_VISIT_ID];
    visitId = timeExpiredCheck(timeDifference, visitId, cookieOptions, cookieHandler);
    updateVisitCookiesArray(visitId, cookies, cookieHandler, cookieOptions);
    return visitId;
  }
};
const handleNewUrlVisitId = (cookies, urlVisitId, urlVisitIdTs, cookieOptions, cookieHandler) => {
  const currentTime = /* @__PURE__ */ new Date();
  const ehVisitIdSetTime = urlVisitIdTs ? new Date(Number(urlVisitIdTs)) : currentTime;
  const timeDifference = timeCalculation(currentTime, ehVisitIdSetTime);
  const visitId = timeExpiredCheck(timeDifference, urlVisitId, cookieOptions, cookieHandler);
  updateVisitCookiesArray(visitId, cookies, cookieHandler, cookieOptions);
  return visitId;
};
const processUrlVisitId = (cookies, urlVisitId, cookieOptions, cookieHandler, urlVisitIdTs) => {
  try {
    const urlVisitIdsArr = cookies[URL_VISIT_IDS] ? JSON.parse(cookies[URL_VISIT_IDS]) : [];
    if (urlVisitIdsArr.includes(urlVisitId)) {
      return handleExistingUrlVisitId(cookies, urlVisitId, urlVisitIdTs, cookieOptions, cookieHandler);
    } else {
      return handleNewUrlVisitId(cookies, urlVisitId, urlVisitIdTs, cookieOptions, cookieHandler);
    }
  } catch (error) {
    logger.error(`Error parsing URL Parameter ${error}`);
    return null;
  }
};
export {
  timeCalculation as a,
  processUrlVisitId as p,
  timeOnPage as t
};
